// @flow
// pdf.js's worker module, loaded on the page itself (not in a Worker) from its URL in www/ or the CDN.
// webpackIgnore keeps the import() native: webpack must not try to bundle the URL.
// $FlowFixMe: Flow 0.111 only takes a literal in import(); this one is a URL on purpose
export const importWorkerModule = (src: string): Promise<any> => import(/* webpackIgnore: true */ src);
